import React from 'react';

import { SVGComponentProps } from './svg.types';

const WhiteboardTemplateSVG = ({
  fill = 'currentColor',
  size = '32',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="16"
        height="15"
        viewBox="0 0 16 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 3.82843C0 3.41968 0 3.2153 0.0761205 3.03153C0.152241 2.84776 0.296756 2.70324 0.585786 2.41421L2.41421 0.585787C2.70324 0.296756 2.84776 0.152241 3.03153 0.0761205C3.2153 0 3.41968 0 3.82843 0H12.1716C12.5803 0 12.7847 0 12.9685 0.0761205C13.1522 0.152241 13.2968 0.296756 13.5858 0.585786L15.4142 2.41421C15.7032 2.70324 15.8478 2.84776 15.9239 3.03153C16 3.2153 16 3.41968 16 3.82843V5.5H0V3.82843ZM11 6.5H16V13C16 13.9428 16 14.4142 15.7071 14.7071C15.4142 15 14.9428 15 14 15H2C1.05719 15 0.585786 15 0.292893 14.7071C0 14.4142 0 13.9428 0 13V6.5H5V10.2515C5 10.9482 5 11.2966 5.08902 11.4839C5.28773 11.9019 5.76499 12.102 6.19749 11.9486C6.39124 11.8799 6.6346 11.6336 7.12132 11.1409C7.34675 10.9127 7.45946 10.7986 7.57931 10.7345C7.84251 10.5936 8.15749 10.5936 8.42069 10.7345C8.54054 10.7986 8.65325 10.9127 8.87868 11.1409C9.3654 11.6336 9.60876 11.8799 9.80251 11.9486C10.235 12.102 10.7123 11.9019 10.911 11.4839C11 11.2966 11 10.9482 11 10.2515V6.5Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default WhiteboardTemplateSVG;
